module.exports = __webpack_public_path__ + "img/loading.c7970183.svg";